<template>
  <section v-if="accountAddress" class="node-reward-withdraw">
    <button
      type="button"
      class="btn-withdraw"
      :disabled="!isNode || withdrawing"
      @click="onWithdraw"
    >
      {{ withdrawing ? "提取中…" : "提取节点奖励" }}
    </button>
    <p v-if="!isNode" class="tip">当前钱包不是节点，无法提取节点奖励</p>
  </section>
</template>

<script>
import { Notify, Toast } from "vant";
import { withdrawNodeReward } from "../helpers/nodeRewardChain.js";

function walletUserRejected(err) {
  const code = err?.code;
  const msg = String(err?.message || err || "").toLowerCase();
  return (
    code === 4001 ||
    code === "ACTION_REJECTED" ||
    msg.includes("user denied") ||
    msg.includes("user rejected") ||
    msg.includes("rejected")
  );
}

export default {
  name: "NodeRewardWithdrawSection",
  props: {
    accountAddress: { type: String, default: "" },
    isNode: { type: Boolean, default: false },
  },
  data() {
    return {
      withdrawing: false,
    };
  },
  methods: {
    async onWithdraw() {
      if (this.withdrawing || !this.isNode) return;
      if (!this.accountAddress) {
        Notify({ type: "warning", message: "请先连接钱包" });
        return;
      }

      this.withdrawing = true;
      Toast.loading({ duration: 0, forbidClick: true });
      try {
        await withdrawNodeReward(this.accountAddress);
        Toast.clear();
        Notify({ type: "success", message: "节点奖励提取成功" });
        this.$emit("success");
      } catch (err) {
        Toast.clear();
        if (walletUserRejected(err)) {
          Notify({ type: "warning", message: "已取消签名" });
          return;
        }
        const apiMsg =
          typeof err?.msg === "string" && err.msg.trim()
            ? err.msg
            : typeof err?.message === "string" && err.message.trim()
              ? err.message
              : "节点奖励提取失败";
        Notify({ type: "danger", message: '节点奖励提取失败' });
      } finally {
        this.withdrawing = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.node-reward-withdraw {
  margin-bottom: 40px;
  text-align: center;
}

.btn-withdraw {
  width: 100%;
  max-width: 480px;
  height: 72px;
  border: none;
  border-radius: 8px;
  background: #e5c486;
  color: #1a1a1a;
  font-size: 28px;
  font-weight: 600;
  cursor: pointer;
}

.btn-withdraw:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.btn-withdraw:active:not(:disabled) {
  filter: brightness(0.97);
}

.tip {
  margin: 16px 0 0;
  font-size: 22px;
  color: #8c8c8c;
}
</style>
